import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { SignUpForm } from "./SignUpForm";
import { UserRole } from '@/types/user-roles';

interface CollapsibleEmailAuthProps {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  organizationName: string;
  isSubmitting: boolean;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onOrganizationNameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  passwordStrength: any;
  onPasswordStrengthChange: (result: any) => void;
}

export const CollapsibleEmailAuth = (props: CollapsibleEmailAuthProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className="w-full justify-center relative text-muted-foreground text-sm py-2"
        >
          Or use e-mail and password
          <div className="absolute right-3">
            {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          </div>
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <SignUpForm {...props} />
      </CollapsibleContent>
    </Collapsible>
  );
};